import React from 'react';
import { ChatSession } from '../services/apiService';

interface ChatHeaderProps {
  activeSessionId: string | null;  // Changed to string for UUID
  chatSessions: ChatSession[];
}

export default function ChatHeader({ activeSessionId, chatSessions }: ChatHeaderProps) {
  const getSessionTitle = () => {
    if (activeSessionId) {
      const session = chatSessions.find(s => s.id === activeSessionId);
      return session?.title || 'Chat Session';
    }
    return 'New Chat Session';
  };

  return (
    <div className="h-14 !hidden border-b theme-border flex items-center px-4 shadow-sm bg-transparent">
      <div className="theme-text font-medium">
        {getSessionTitle()}
      </div>
    </div>
  );
}
